// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3kAu9","left":"InfoRow_left__3h7LR"};